var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgBeautyCancel = function SvgBeautyCancel(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2004_58274)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 27.36L30.96 34.32C31.4 34.76 31.96 34.98 32.64 34.98C33.32 34.98 33.88 34.76 34.32 34.32C34.76 33.88 34.98 33.32 34.98 32.64C34.98 31.96 34.76 31.4 34.32 30.96L27.36 24L34.32 17.04C34.76 16.6 34.98 16.04 34.98 15.36C34.98 14.68 34.76 14.12 34.32 13.68C33.88 13.24 33.32 13.02 32.64 13.02C31.96 13.02 31.4 13.24 30.96 13.68L24 20.64L17.04 13.68C16.6 13.24 16.04 13.02 15.36 13.02C14.68 13.02 14.12 13.24 13.68 13.68C13.24 14.12 13.02 14.68 13.02 15.36C13.02 16.04 13.24 16.6 13.68 17.04L20.64 24L13.68 30.96C13.24 31.4 13.02 31.96 13.02 32.64C13.02 33.32 13.24 33.88 13.68 34.32C14.12 34.76 14.68 34.98 15.36 34.98C16.04 34.98 16.6 34.76 17.04 34.32L24 27.36ZM24 48C20.68 48 17.56 47.37 14.64 46.11C11.72 44.85 9.18 43.14 7.02 40.98C4.86 38.82 3.15 36.28 1.89 33.36C0.63 30.44 0 27.32 0 24C0 20.68 0.63 17.56 1.89 14.64C3.15 11.72 4.86 9.18 7.02 7.02C9.18 4.86 11.72 3.15 14.64 1.89C17.56 0.63 20.68 0 24 0C27.32 0 30.44 0.63 33.36 1.89C36.28 3.15 38.82 4.86 40.98 7.02C43.14 9.18 44.85 11.72 46.11 14.64C47.37 17.56 48 20.68 48 24C48 27.32 47.37 30.44 46.11 33.36C44.85 36.28 43.14 38.82 40.98 40.98C38.82 43.14 36.28 44.85 33.36 46.11C30.44 47.37 27.32 48 24 48ZM24 43.2C29.36 43.2 33.9 41.34 37.62 37.62C41.34 33.9 43.2 29.36 43.2 24C43.2 18.64 41.34 14.1 37.62 10.38C33.9 6.66 29.36 4.8 24 4.8C18.64 4.8 14.1 6.66 10.38 10.38C6.66 14.1 4.8 18.64 4.8 24C4.8 29.36 6.66 33.9 10.38 37.62C14.1 41.34 18.64 43.2 24 43.2Z",
    fill: "#A0A5AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2004_58274",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2.66667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2004_58274"
  })))));
};
export default SvgBeautyCancel;